<template lang="pug">
    .main-layout
        layout-header(:floating="true")
        slot
        layout-footer

</template>

<script>
export default {
    name: 'main-layout',

    computed: {
        title() {
            return this.$route.meta.title || ''
        },
    },
}
</script>
